"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Avatar.css");

var _avatar = _interopRequireDefault(require("../assets/svg/avatar.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      rounded = _ref.rounded,
      size = _ref.size,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["src", "rounded", "size", "className"]);

  var wrapperClass = 'avatar';
  if (rounded) wrapperClass += ' avatar--rounded';
  if (size === 'small') wrapperClass += ' avatar--small';
  if (size === 'big') wrapperClass += ' avatar--big';
  if (className) wrapperClass += " ".concat(wrapperClass);
  return _react.default.createElement("figure", _extends({}, props, {
    className: wrapperClass
  }), _react.default.createElement("img", {
    src: src,
    className: "avatar__image",
    alt: "Avatar"
  }));
};

Avatar.defaultProps = {
  src: _avatar.default,
  rounded: false,
  size: ''
};
Avatar.propTypes = {
  /** URL da imagem */
  src: _propTypes.default.string.isRequired,

  /** Indica se será exibido dentro de um círculo */
  rounded: _propTypes.default.bool,

  /** Indica o tamanho do avatar que será exibido */
  size: _propTypes.default.string
};
var _default = Avatar;
exports.default = _default;